import { gql } from '@apollo/client';

interface IItem {
  id: number;
  amount: number;
  sum: number;
}
export interface IGoodItem extends IItem {
  type: 'GOOD';
  entity: {
    id: number;
    title: string;
  };
}
export interface ITariffItem extends IItem {
  type: 'TARIFF';
  entity: {
    id: number;
    title: string;
    per_minute: boolean;
  };
}
export interface IServiceItem extends IItem {
  type: 'SERVICE';
  entity: {
    id: number;
    title: string;
  };
}
export interface IGetWorkShiftPaymentsResponse {
  activeWorkShift: {
    payments: Array<{
      is_refunded: boolean;
      items: Array<IGoodItem | IServiceItem | ITariffItem>;
    }>;
  } | null;
}
export const GET_WORKSHIFT_PAYMENTS = gql`
  query workshiftPayments {
    activeWorkShift {
      payments {
        is_refunded
        status
        items {
          id
          amount
          type
          sum
          entity {
            ... on Service {
              id
              title
            }
            ... on Good {
              id
              title
            }
            ... on Tariff {
              id
              title
              per_minute
            }
          }
        }
      }
    }
  }
`;
